export const HttpStatusCode = {
  MovedPermanently: 301,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  NotAcceptable: 406,
  UnprocessableEntity: 422,
  InternalServerError: 500,
};
